import React from 'react';
import { bool, string, func, number } from 'prop-types';
import SnackbarMaterial from 'material-ui/Snackbar';
import IconButton from 'material-ui/IconButton';
import { Link } from 'react-router-dom';

import Message from './Message';
import SnackbarButton from './SnackbarButton';

const Snackbar = ({
  open,
  message,
  buttonTitle,
  onClose,
  onClick,
  linkTo,
  linkButton = false,
  time = 6000,
  vertical = 'bottom',
  horizontal = 'left'
}) => {
  const handleCloseSnackbar = (event, reason) => {
    reason !== 'clickaway' && onClose();
  };

  return (
    <SnackbarMaterial
      anchorOrigin={{ vertical, horizontal }}
      open={open}
      autoHideDuration={time}
      onRequestClose={handleCloseSnackbar}
      message={<Message>{message}</Message>}
      action={[
        <SnackbarButton
          key="snackbar-button"
          component={linkButton ? Link : undefined}
          to={linkButton ? linkTo : undefined}
          onClick={onClick}
        >
          {buttonTitle}
        </SnackbarButton>,
        <IconButton
          key="close"
          aria-label="Close"
          color="inherit"
          onClick={handleCloseSnackbar}
        >
          <i className="material-icons">close</i>
        </IconButton>,
      ]}
    />
  );
};

Snackbar.propTypes = {
  open: bool.isRequired,
  message: string.isRequired,
  buttonTitle: string.isRequired,
  onClose: func.isRequired,
  onClick: func,
  linkButton: bool,
  linkTo: string,
  time: number,
  horizontal: string,
  vertical: string
};

export default Snackbar;



// WEBPACK FOOTER //
// ./src/components/common/Snackbar/index.js